import PropTypes from 'prop-types'
import ContextMenuComponent from '../../../context-menu'
import {
  contextMenuAlignOptions,
  contextMenuVariantOptions,
  contextMenuTitleWeightOptions
} from '../../../context-menu/constants'
import UserAvatar from './user-avatar'
import UserData from './user-data'
import { useIntl } from 'react-intl'
import { ExpiredFlag } from '../../styled-components'
import { useState } from 'react'
import { useGetAvatarQuery } from '../../../../../../react-query/avatar/query/use-get-avatar-query'

const UserMenu = ({
  userData,
  isExpired,
  profilePicture = null,
  onClickLogout,
  onClickUserSettings,
  appVersion,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { formatMessage } = useIntl()

  const { data: cachedAvatarImage, isError: avatarImageHasError } =
    useGetAvatarQuery(profilePicture)

  const renderedAvatarImage =
    cachedAvatarImage || (avatarImageHasError ? profilePicture : null)

  const HandleUserAvatar = () => {
    if (isExpired) {
      return (
        <ExpiredFlag>
          <UserAvatar key="avatar" profilePicture={renderedAvatarImage} />
        </ExpiredFlag>
      )
    }

    return <UserAvatar key="avatar" profilePicture={renderedAvatarImage} />
  }

  const handleClose = () => setIsOpen(false)

  const handleClickUserSettings = (callBack) => {
    onClickUserSettings()
    handleClose()
  }

  return (
    <ContextMenuComponent.Root isOpen={isOpen} setIsOpen={setIsOpen}>
      <ContextMenuComponent.Trigger>
        {HandleUserAvatar()}
      </ContextMenuComponent.Trigger>
      <ContextMenuComponent.List
        align={contextMenuAlignOptions.START}
        width="240px"
      >
        <UserData name={userData?.name} profilePicture={renderedAvatarImage} />

        <ContextMenuComponent.Item
          id="user-settings"
          title={formatMessage({ id: 'userSettings_userSettings' })}
          titleWeight={contextMenuTitleWeightOptions['TEXT-600']}
          onClick={handleClickUserSettings}
        />

        {children}

        <ContextMenuComponent.Item
          variant={contextMenuVariantOptions.DESTRUCTIVE}
          id="logout"
          title={formatMessage({ id: 'userSettings_logout' })}
          titleWeight={contextMenuTitleWeightOptions['TEXT-600']}
          onClick={onClickLogout}
        />

        <ContextMenuComponent.Item
          variant={contextMenuVariantOptions.RESTRICTED}
          id="version"
          title={formatMessage({ id: 'app_version' }, { version: appVersion })}
          titleWeight={contextMenuTitleWeightOptions['TEXT-600']}
        />
      </ContextMenuComponent.List>
    </ContextMenuComponent.Root>
  )
}

UserMenu.propTypes = {
  userData: PropTypes.object,
  onClickLogout: PropTypes.func,
  onClickUserSettings: PropTypes.func,
  appVersion: PropTypes.string,
  children: PropTypes.node,
  profilePicture: PropTypes.string
}

export default UserMenu
